import { Directive, OnDestroy, inject, AfterViewInit } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import { FormStateService } from '@core/services/form-state.service';
import { toObservable } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[appDirtyCheck]',
  standalone: true
})
export class DirtyCheckDirective implements AfterViewInit, OnDestroy {
  private _formStateService: FormStateService = inject(FormStateService);

  private _formGroupDirective: FormGroupDirective = inject(FormGroupDirective);

  private _isDirty$: Observable<boolean> = toObservable(this._formStateService.isDirty);

  private $destroy: Subject<void> = new Subject<void>();

  public ngAfterViewInit (): void {
    this._formGroupDirective.form.valueChanges
      .pipe(takeUntil(this.$destroy))
      .subscribe(() => {
        if (this._formGroupDirective.form.dirty)
          this._formStateService.markDirty();
      });
    this._isDirty$
      .pipe(
        filter((isDirty: boolean) => !isDirty)
      ).subscribe(() => {
        this._formGroupDirective.form.reset();
        this._formGroupDirective.form.markAsPristine();
      });
  }

  public ngOnDestroy (): void {
    this.$destroy.next();
  }
}
